import { DashboardTiles } from '@common/constants';
import { TilesProps } from '@common/types';
import { useAddDashboardTile, useRemoveDashboardTile } from '@hooks/dashboard';
import { useLicencesAssignmentQuery } from '@hooks/licenses';
import { DoughnutChartTile } from '@pages/InsightsAndAnalytics/tiles/DoughnutChartTile';
import { pickSummary, useDualUtilisationData } from '@hooks/summary';
import { toLicensesAssignment } from '@hooks/summary/adapters';

export const UnassignedLicensesSnapshot: React.FC<TilesProps> = ({
  params,
  id,
  classNames,
}) => {
  const parsedParams = JSON.parse(params);
  const { removeMenuItem } = useRemoveDashboardTile(id);
  const { addMenuItem } = useAddDashboardTile(
    DashboardTiles.UnassignedLicensesSnapshot,
    ''
  );
  const isOnDashboardPage = !!id;

  const {
    data: licencesAssignmentData,
    isLoading: isLicencesAssignmentLoading,
  } = useDualUtilisationData({
    legacyParams: parsedParams,
    useLegacyQuery: useLicencesAssignmentQuery,
    mapSummary: (grouped) =>
      toLicensesAssignment(
        pickSummary(grouped, 'Subscriptions')
      ),
  });

  return (
    <DoughnutChartTile
      classNames={'col-span-6 md:col-span-3 xl:col-span-2'}
      dropdownMenuItemClasses={'!w-[300px]'}
      headerTitle={'Unassigned licenses: Snapshot'}
      contextData={isOnDashboardPage ? removeMenuItem : addMenuItem}
      isLoading={isLicencesAssignmentLoading}
      data={licencesAssignmentData ? Object.values(licencesAssignmentData) : []}
      dataLabels={['Unassigned licenses', 'Assigned licenses']}
    />
  );
};
